<template>   

<!-- <section class="py-6 dark:bg-gray-800 dark:text-gray-50">
		<div class="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4" >
			<img alt="" class="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-3 md:row-start-1 dark:bg-gray-500 aspect-square" src="..\assets\highlight1Thumb.jpg">
			<diV v-for="murl in photoData.url" :key=murl.idkey>
                <img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" :src=murl>
            </div>
            <img src="..\assets\action\main2.jpg" alt="" class="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-1 md:row-start-3 dark:bg-gray-500 ">
		</div>
        <h1 class="hubub">Nike Camp at Life Time Fitness in San Clemente, CA - Apr 17/18 2023 </h1>
        <div class="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4">
			<img src="..\assets\highlight2Thumb.jpg" data-modal-target="modal2" data-modal-toggle="modal2" alt="" class="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-3 md:row-start-1 dark:bg-gray-500 aspect-square">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="..\assets\paddleCover.jpg"> 
			
		</div>
	</section>     -->

<div class="grid grid-cols-2 md:grid-cols-3 gap-4">
    <div   v-for="murl in photoData.url" :key=murl.idkey>
        <a v-if="!vidChecker(murl)" target="_blank" :href=murl>
            <img class="h-auto max-w-full rounded-lg aspect-square" :src=murl alt="">
        </a>
        
        <video v-if="vidChecker(murl)" class="w-full rounded-base" controls>
            <source :src=murl type="video/mp4">
              Your browser does not support the video tag.
        </video>

    </div>   
</div>





<!-- <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
    <div v-for="murl in urlHolder" :key=murl.idkey class="grid gap-4">
        <div>
            <img class="h-auto max-w-full rounded-lg" :src=murl[0] alt="">
        </div>
        <div>
            <img class="h-auto max-w-full rounded-lg" :src=murl[1] alt="">
        </div>
        <div>
            <img class="h-auto max-w-full rounded-lg" :src=murl[2] alt="">
        </div>
    </div>
   
  
    <div class="grid gap-4">
        <div>
            <img class="h-auto max-w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-6.jpg" alt="">
        </div>
        <div>
            <img class="h-auto max-w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-7.jpg" alt="">
        </div>
        <div>
            <img class="h-auto max-w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-8.jpg" alt="">
        </div>
    </div>
    <div class="grid gap-4">
        <div>
            <img class="h-auto max-w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-9.jpg" alt="">
        </div>
        <div>
            <img class="h-auto max-w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-10.jpg" alt="">
        </div>
        <div>
            <img class="h-auto max-w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-11.jpg" alt="">
        </div>
    </div>
</div>	 -->


</template>

<script>
import { onMounted,onUpdated, ref } from "@vue/runtime-core"
import { useRoute } from "vue-router"
import { doc, getDoc } from '@firebase/firestore'
import { db } from '@/firebase/config'
import { initCarousels, Carousel } from "flowbite"
import { MenuItems } from "@headlessui/vue"



export default {
    setup(){
        
        const route = useRoute()
        const photoData = ref({})
        const paramId = ref()
        const carousel = ref()
        const carouselParams = ref({})
        let photoArry = []
        let urlHolder = ref([])

        onMounted(()=>{
            paramId.value = route.params.albumid
            albumGetter(paramId.value)
           
        })
        
       
        const albumGetter = async (docid)=> {   
            const docRef = doc(db, "albums", docid);            
            let docSnap = await getDoc(docRef)
            if (docSnap.exists()) {              
                photoData.value = ({ ...docSnap.data()})
                photoArry = [...photoData.value.url]
                
                let loopCount = 0;
                let threeHold = []
                for(let i = 0; i < photoArry.length; i++){
                    
                    if (i % 3 == 0 && i != 0){                                               
                        urlHolder.value.push(threeHold)
                        
                        threeHold = []
                        threeHold.push(photoArry[i])
                    }
                    else if(i == photoArry.length - 1){
                        threeHold.push(photoArry[i])
                        urlHolder.value.push(threeHold)
                    }
                    else{
                        threeHold.push(photoArry[i])
                    }
                   
                }
                
                
            } else {
                // doc.data() will be undefined in this case
				photoData.value = {
					name : "no album found"
				}
                console.log("No such event!");
            }

        }

        const vidChecker = (file) =>{
            const mp4Regex = /\.mp4$/i
            return mp4Regex.test(file) 

        }

        return { photoData, urlHolder, vidChecker}
    }
    
}
</script>

<style>

</style>